import React, { FC } from 'react';
import { Page } from 'app/modules/insights/types/Page';
import { Dayjs } from 'dayjs';
import { BrandLogo, SocialMediaIcon } from '@kontentino/ui';
import getSocialMediaTypeForBrandLogo from 'app/utils/getSocialMediaTypeForBrandLogo';
import PageTypeUtils from 'app/utils/pageType';
import { formatDate } from '@kontentino/kontentino-utils/date';

type Props = {
  page: Page;
  startDate: Dayjs;
  endDate: Dayjs;
  className?: string;
  name?: string;
  is12hDateFormat?: boolean;
  title?: string;
};

const ReportHeader: FC<Props> = ({
  startDate,
  endDate,
  page,
  name,
  className,
  is12hDateFormat = false,
  title,
}) => {
  return (
    <div
      className={className}
      style={{
        breakInside: 'avoid',
        breakBefore: 'page',
        pageBreakBefore: 'always',
        paddingBottom: '12px',
      }}
    >
      <div className="tw-flex tw-flex-1 tw-justify-between tw-border-b tw-border-grayscale-20 tw-pb-4">
        <div className="tw-flex tw-items-center tw-gap-4">
          <BrandLogo size={52} src={page.picture ?? ''} />
          <div className="tw-text-md">
            <span>{page.name}</span>
            <div className="tw-flex tw-items-center tw-gap-3">
              <SocialMediaIcon
                size={24}
                variant="plain"
                type={getSocialMediaTypeForBrandLogo(page._type)!}
              />
              <span>{PageTypeUtils.getLabel(page._type)}</span>
            </div>
          </div>
        </div>
        <div className="tw- tw-flex tw-flex-col tw-items-center">
          {name && <span>{name}</span>}
          <span>{`${formatDate(startDate, is12hDateFormat)} - ${formatDate(
            endDate,
            is12hDateFormat,
          )}`}</span>
        </div>
      </div>
      {title && (
        <div className="tw-mt-2 tw-flex tw-items-center tw-justify-between">
          <span className="tw-text-xl tw-font-bold">{title}</span>
        </div>
      )}
    </div>
  );
};

export default ReportHeader;
